window.theme.component('form', el => {
    const form = el.querySelector('form.wpcf7-form');
    const controlSubmit = el.querySelector('.js-submit-cf7');
    const submitWrapper = el.querySelector('.js-submit-wrapper');
    const spinner = el.querySelector('.js-spinner');

    // Move the button inside the form.
    if (submitWrapper && controlSubmit) {
        controlSubmit.insertAdjacentElement('afterend', submitWrapper);
    }

    // Show or hide spinner based on form responses.
    if (form && spinner) {
        form.addEventListener('submit', function () {
            spinner.style.display = 'block';
        });

        el.addEventListener('wpcf7mailsent', function () {
            spinner.style.display = 'none';
        });

        el.addEventListener('wpcf7mailfailed', function () {
            spinner.style.display = 'none';
        });

        el.addEventListener('wpcf7invalid', function () {
            spinner.style.display = 'none';
        });

        form.addEventListener('wpcf7submit', function (event) {
            if (event.detail.apiResponse && event.detail.apiResponse.invalid_fields) {
                spinner.style.display = 'none';
            }
        });
    }
});
